<template>

<app-wrapper :fill="!reviews.length" :loading="is.loading">

	<app-empty v-if="!reviews.length">{{ textEmpty }}</app-empty>

	<app-review :text="text" v-for="(review, index) in reviews" :key="index" :review="review" :viewAs="viewAs" />

    <app-pagination :pages="pages" :current="current" v-on:change="onPageChange" />

</app-wrapper>

</template>

<script>

export default {

    data: function() {

        return {
            is: {
                loading: false
            },
            reviews: [],
            pages: 1,
            current: 1,
            total: 0
        }

    },

	computed: {

        text: function() {

            var prefix = (this.isSessionCustomer) ? 'customer_reviews_' : 'business_reviews_'

            return {
                read: {
                    created_prefix: this.page[prefix + 'read_created_prefix'],
                    pending_label: this.page[prefix + 'read_status_pending_label'],
                    pending_tooltip: this.page[prefix + 'read_status_pending_tooltip'],
                    recommendation_title: this.page[prefix + 'read_recommendation_title'],
                    recommendation_yes: this.page[prefix + 'read_recommendation_yes'],
                    recommendation_no: this.page[prefix + 'read_recommendation_no'],
                    date_title: this.page[prefix + 'read_date_title'],
                    time_title: this.page[prefix + 'read_time_title'],
                    contact_title: this.page[prefix + 'read_contact_title'],
                    respond_button: this.page[prefix + 'read_respond_button'],
                    respond_prompt: this.page[prefix + 'read_respond_prompt'],
                    delete_button: this.page[prefix + 'read_delete_button']
                },
                report: {
                    title: this.page['business_reviews_report_title'],
                    description: this.page['business_reviews_report_description'],
                    text_label: this.page['business_reviews_report_text_label'],
                    text_placeholder: this.page['business_reviews_report_text_placeholder'],
                    reason_label: this.page['business_reviews_report_reason_label' ],
                    reason_placeholder: this.page['business_reviews_report_reason_placeholder'],
                    message_success: this.page['business_reviews_report_message_success'],
                    message_error: this.page['business_reviews_report_message_error'],
                    button_save: this.page['business_reviews_report_button_save'],
                    button_cancel: this.page['business_reviews_report_button_cancel']
                }
            }

        },

		viewAs: function() {

            return (this.isSessionCustomer) ? 'customer' : 'business'

        },

        textEmpty: function() {

            return (this.isSessionCustomer) ? this.page.customer_reviews_empty : this.page.business_reviews_empty

        }

    },
    
    created: function() {

        this.fetch()

        this.$pubsub.$on('account/reviews/refresh', this.fetch.bind(this))

    },

    beforeDestroy: function() {

        this.$pubsub.$off('account/reviews/refresh', this.fetch.bind(this))

    },

    methods: {

        onPageChange: function(value) {

            this.current = value
            this.fetch()

        },

        fetch: function() {

            this.is.loading = true

            this.$api.request('account/reviews', {
                page: this.current
            }).then(function(json) {

                this.reviews = json.items
                this.pages = json.pages
                this.current = json.page 
                this.total = json.total

                this.is.loading = false

            }.bind(this))

        }

    }

}

</script>